<div class="step-content">
  <app-input-select [formData]="deviceSelect" />
</div>